module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("97KE1"))).then(() => parcelRequire('d0iPb'));